import React from "react";
import { Modal, List, Typography, Flex, Button, Col, Spin } from "antd";

const { Text } = Typography;

const ProductHistoryModal = ({
	visible,
	onClose,
	product,
	restoreDescription,
	restoreButtonLoading,
}) => {
	if (!product) return null; // Ensure product data exists

	return (
		<Modal
			title={`History for ${product.title}`}
			open={visible}
			onCancel={onClose}
			footer={null}
			width={600}
			style={{
				
			}}
		>
			<Spin spinning={restoreButtonLoading}>
			<List
				bordered
				dataSource={product.history}
				style={{
					maxHeight: "70vh",
					overflow: "auto",
					borderRadius: "8px",
				}}
				renderItem={(item, index) => (
					<List.Item>
						<Col span={24}>
							<Flex vertical>
								<div>
									<Text strong>{`Version ${index + 1} - ${new Date(
										item.updatedAt
									).toLocaleString()}`}</Text>
									<p style={{ marginTop: 8 }}>{item.oldDescription}</p>
								</div>
								<Flex justify="end">
									<Button
										loading={restoreButtonLoading}
										type="default"
										block
										style={{
											maxWidth: "140px",
											borderRadius: "8px",
											border: "1px solid #6D5BBA",
											color: "#6D5BBA",
											fontWeight: 500,
										}}
										onClick={() => {
											restoreDescription(
												product?.productId,
												item.oldDescription,
												product?.newDescription
											);
										}}
									>
										Restore
									</Button>
								</Flex>
							</Flex>
						</Col>
					</List.Item>
				)}
			/>
			</Spin>
		</Modal>
	);
};

export default ProductHistoryModal;
